export default {
    id: null,
    status: "",
    title: "",
    content: "",
};
